import { userHasAnyAccess } from './accessUtils';
import { DEFAULT_CATALOG_VITRINE_SETTINGS } from '../constants/catalogVitrineSettings';

/**
 * Política unificada de visibilidade do catálogo na web.
 * Vitrine, filtros por tag e listagem geral seguem catalogSettings.
 */
export function shouldRestrictCatalogToUserAccessWeb(settings, userData) {
  const restrict =
    settings?.restrictToUserProductsWeb ??
    DEFAULT_CATALOG_VITRINE_SETTINGS.restrictToUserProductsWeb;

  return restrict && userHasAnyAccess(userData);
}
